import { Component, Input, OnInit, inject } from '@angular/core';
import { SessionStorageService } from '../../../services/session-storage.service';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { ClipboardService } from 'ngx-clipboard';
import {
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  Location,
  PercentPipe,
} from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxLoadingModule } from 'ngx-loading';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-card-infopoint',
  templateUrl: './card-infopoint.component.html',
  styleUrls: ['./card-infopoint.component.scss'],
  imports: [
    NgxLoadingModule,
    DatePipe,
    CurrencyPipe,
    PercentPipe,
    DecimalPipe,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class CardInfopointComponent implements OnInit {
  private location = inject(Location);
  private route = inject(Router);
  ss = inject(SessionStorageService);
  private rbs = inject(RightBridgeApiService);
  dialog = inject(MatDialog);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);

  @Input() datapoint;
  @Input() dataset;
  @Input() disableDecryption: boolean = false;
  rights = [];
  loading = false;

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
  }

  nav(location, external = false) {
    if (external) {
      window.open(
        `${this.location.prepareExternalUrl(`/${location}`)}`,
        '_blank'
      );
    } else {
      this.route.navigate([`/${location}`]);
    }
  }

  decryptValue(value: string, title: string) {
    this.loading = true;
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        this.loading = false;
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        this.loading = false;
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
